import React, { Component } from 'react';
import PropTypes from 'prop-types';

import css from './SetPasswordAndConfirm.module.scss';
import Input from '../../../components/UI/CustomInputField';
import WidgetPropTypes from '../types';
import WidgetPagePropTypes from '../../WidgetPage/types';
import PasswordValidation from '../../../components/UI/PasswordValidation/index.tsx';

export const WIDGET_NAME = 'set_user_password_and_confirm';
export const MISMATCH_PASSWORD_ERROR = 'Please confirm both passwords match';

class SetPasswordAndConfirm extends Component {
  state = {
    password: '',
    passwordError: false,
    confirmPassword: '',
    confirmPasswordError: false,
    confirmPasswordMessage: '',
    typingPassword: false,
    passwordTooShort: true,
    passwordRequiresLetter: true,
    passwordRequiresNumber: true
  };

  componentDidMount() {
    if (!this.props.resetPassword) {
      this.props.analytics.trackEvent('Registration Enter Password Viewed', {
        eventProps: {
          role: this.props.app.answers.setRole
        }
      });
    }
  }

  validatePassword = value => value.match(/^(?=.*[A-Za-z])(?=.*\d)(.*){8,}$/);

  onChangePassword = value => {
    const { changeAnswerValue, widget } = this.props;

    const match = this.validatePassword(value);

    changeAnswerValue(widget, value);

    if (this.state.typingPassword === false) {
      this.setState({
        typingPassword: true
      });
    }
    if (value.length > 7) {
      this.setState({
        passwordTooShort: false
      });
    } else {
      this.setState({
        passwordTooShort: true
      });
    }
    if (/[a-zA-Z]/.test(value)) {
      this.setState({
        passwordRequiresLetter: false
      });
    } else {
      this.setState({
        passwordRequiresLetter: true
      });
    }
    if (/\d/.test(value)) {
      this.setState({
        passwordRequiresNumber: false
      });
    } else {
      this.setState({
        passwordRequiresNumber: true
      });
    }

    this.setState({
      password: value,
      valid: match != null && match.length > 0
    });
  };

  onChangeConfirmPassword = value => {
    const match = this.validatePassword(value);

    this.setState({
      confirmPassword: value,
      valid: match != null && match.length > 0
    });
  };

  componentDidUpdate(prevProps, prevState) {
    const { widget, shouldEnable } = this.props;
    if (
      prevState.password !== this.state.password ||
      prevState.confirmPassword !== this.state.confirmPassword
    ) {
      if (
        this.state.password.length > 7 &&
        this.state.confirmPassword.length > 7
      ) {
        shouldEnable(widget, true);
      } else {
        shouldEnable(widget, false);
      }
    }
  }

  errorChecking = async () => {
    if (this.state.password !== this.state.confirmPassword) {
      this.setState({
        passwordError: false,
        confirmPasswordError: true,
        confirmPasswordMessage: MISMATCH_PASSWORD_ERROR
      });
      throw new Error();
    }
    if (!/^(?=.*[A-Za-z])(?=.*\d)(.*){8,}$/.test(this.state.password)) {
      this.setState({
        passwordError: true,
        confirmPasswordError: false,
        confirmPasswordMessage: ''
      });
      throw new Error();
    }
    if (this.state.confirmPassword === this.state.password) {
      this.setState({
        error: false,
        dontMatch: false,
        passwordError: false,
        confirmPasswordError: false,
        confirmPasswordMessage: ''
      });
      return false;
    }
    this.setState({
      error: true,
      dontMatch: this.state.confirmPassword !== this.state.password
    });
    throw new Error();
  };

  render() {
    const error =
      this.state.error ||
      this.state.passwordError ||
      this.state.confirmPasswordError;

    return (
      <div>
        <Input
          id="passwordId"
          placeholder="Create password"
          onClick={this.props.onClick}
          error={
            (this.state.error && this.state.dontMatch) ||
            this.state.passwordError
          }
          autoComplete="off"
          autoCorrect="off"
          type="password"
          format={
            !this.state.typingPassword
              ? `Must be 8+ characters and at least 1 number`
              : ''
          }
          onChange={value => {
            this.onChangePassword(value.trim());
          }}
          className="ParentInfo2-Custom-Input fs-mask"
          data-e2e="password"
        />
        {this.state.typingPassword && (
          <div className={css.passwordValidation}>
            <PasswordValidation
              isValid={!this.state.passwordTooShort}
              isError={!!error}
              label="Must be 8+ characters"
              dataTestIdFailed="password-too-short"
              dataTestIdPassed="password-long-enough"
            />
            <PasswordValidation
              isValid={!this.state.passwordRequiresLetter}
              isError={!!error}
              label="Must contain at least one letter"
              dataTestIdFailed="password-no-letter"
              dataTestIdPassed="password-contains-letter"
            />

            <PasswordValidation
              isValid={!this.state.passwordRequiresNumber}
              isError={!!error}
              label="Must contain at least one number"
              dataTestIdFailed="password-no-number"
              dataTestIdPassed="password-contains-number"
            />
          </div>
        )}
        <Input
          id="confirmPasswordId"
          placeholder="Confirm password"
          error={this.state.confirmPasswordError}
          autoComplete="off"
          autoCorrect="off"
          onClick={this.props.onClick}
          type="password"
          onChange={value => {
            this.onChangeConfirmPassword(value.trim());
          }}
          className="fs-mask"
          format={this.state.confirmPasswordMessage}
          data-e2e="confirm-password"
        />
      </div>
    );
  }
}

export default SetPasswordAndConfirm;
